// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1KcTM","subheader":"ReorderModal_subheader__es-0H","listWrap":"ReorderModal_listWrap__3CIsF"};